import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import EmployeeAvatar from '@/components/EmployeeAvatar.vue';
    import type { Employee } from '@/types';
    import {
        Dialog,
        DialogClose,
        DialogContent,
        DialogBody,
        DialogFooter,
        DialogHeader,
        DialogTitle,
        DialogTrigger,
    } from '@/components/ui/dialog';
    import { Button } from '@/components/ui/button';
    import { useI18n } from 'vue-i18n';
    import ContinueButton from '@/components/ContinueButton.vue';
    import EmployeeChangesTabs from '@/components/employees/EmployeeChangesTabs.vue';
    import axios from 'axios';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';
    import { useMutation } from '@tanstack/vue-query';
    import { toast } from 'vue-sonner';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed, ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OpenEmployeeChanges',
  props: {
    employee: {}
  },
  setup(__props: any) {

    const { t } = useI18n();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const queryClient = useQueryClient();
    const isOpen = ref(false);

    const props = __props;

    const { hasPermission } = usePermissions();

    const { mutate, isPending } = useMutation({
        mutationFn: () => {
            return axios.post(route('v2.salary.employee.changes.noted', { id: props.employee.id }));
        },
        onSuccess: (data) => {
            toast.success(t('forms.general.success'));
            queryClient.invalidateQueries({ queryKey: [QueryKey.EMPLOYEES, selectedCompanyId] });
            isOpen.value = false;
        },
        onError: (error: any) => {
            toast.error(t('forms.system_error'));
        },
    });

    const changesNoted = () => {
        mutate();
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: isOpen.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(ContinueButton, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('forms.open')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-3xl" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('employee.table.changes')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), null, {
            default: _withCtx(() => [
              _createVNode(EmployeeChangesTabs, { employee: _ctx.employee }, null, 8, ["employee"])
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogClose), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "sm"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (
                        _unref(hasPermission)(_unref(Permission).EMPLOYEES_UPDATE) &&
                        ((_ctx.employee.log && !_ctx.employee.log.changes_noted) || _ctx.employee.unnoted_salary)
                    )
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    size: "sm",
                    onClick: changesNoted,
                    disabled: _unref(isPending),
                    loading: _unref(isPending)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.note_change')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})